import React, { Component } from 'react'

export class Comment extends Component {
  render() {
    return (
      <React.Fragment>
        <p className='Comments'>
          <a href={`mailto:${this.props.email}`}>
            {this.props.revision_number && `${this.props.revision_number}: `} {this.props.name}
          </a>
          <span>&nbsp;({this.props.date}):&nbsp;</span>
          {this.props.comment || <span style={{ color: 'grey' }}>Entered no comment.</span>}
        </p>
      </React.Fragment>
    )
  }
}
